// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Dupa","large":"_1scd5"};